import React, { useState } from 'react'
import { CardBody, Container, Row } from 'reactstrap'
import { Slider, TextField, Button, Card, CardContent, Typography } from "@mui/material";
import PlanHeader from '../../../Components/settings/PlansAndPricingComponent/CreatePlan/ValidationForm/PlanHeader';
import axiosInstance from '../../../Utils/axiosInstance';


function HistoricalVar() {
    const [confidence, setConfidence] = useState(95);
    const [investment, setInvestment] = useState(100000);
    const [result, setResult] = useState<{ var?: number; error?: string, cvar?: string } | null>(
        null
    );

    const calculateVaR = async () => {
        try {
            const response = await axiosInstance.get(
                `http://127.0.0.1:8000/paper-app/risk-management/historical-var/?confidence_level=${confidence}&investment_amount=${investment}`
            );
            console.log(response.data)
            setResult(response.data);
        } catch (error) {
            setResult({ error: "Failed to fetch data" });
        }
    };

    return (
        <div className="page-body">
            <Container fluid>
                <Row>
                    <div>
                        <PlanHeader headClass='pb-4 card' title={"Plans And Pricing"} subTitle={"Create New plans and pricing"} />
                        <Card className="height-equal">
                            <div className="d-flex align-items-center">
                                <CardBody className="d-flex     ">
                                    <div className="flex justify-center items-center min-h-screen bg-gray-100">
                                        <Card sx={{ p: 4, maxWidth: 400, width: "100%", boxShadow: 3 }}>
                                            <Typography variant="h5" fontWeight="bold" align="center" gutterBottom>
                                                Oil Trading VaR Calculator
                                            </Typography>
                                            <CardContent>
                                                {/* Confidence Level Slider */}
                                                <Typography gutterBottom>Confidence Level: {confidence}%</Typography>
                                                <Slider
                                                    value={confidence}
                                                    min={90}
                                                    max={99}
                                                    step={0.5}
                                                    onChange={(_, val) => setConfidence(val as number)}
                                                    valueLabelDisplay="auto"
                                                    sx={{ mb: 2 }}
                                                />

                                                {/* Investment Amount Input */}
                                                <TextField
                                                    label="Investment Amount ($)"
                                                    type="number"
                                                    value={investment}
                                                    onChange={(e) => setInvestment(Number(e.target.value))}
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                {/* Calculate Button */}
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    sx={{ mt: 2 }}
                                                    onClick={calculateVaR}
                                                >
                                                    Calculate VaR
                                                </Button>

                                                {/* Display Result */}
                                                {result && (
                                                    <Card sx={{ mt: 3, p: 2, backgroundColor: "#f9f9f9" }}>
                                                        {result.error ? (
                                                            <Typography color="error">{result.error}</Typography>
                                                        ) : (
                                                            <Typography variant="h6">
                                                                Value at Risk (VaR): ${result.var?.toFixed(2)}
                                                                Expected Shortfall(cvar): ${result.cvar}
                                                            </Typography>
                                                        )}
                                                    </Card>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </div>
                                </CardBody>
                            </div>
                        </Card>
                    </div>
                </Row>
            </Container>
        </div>
    );
}

export default HistoricalVar